export default "__VITE_ASSET__CNZWJGqv__"